import { useAuth0 } from '@auth0/auth0-react';
import { useOrganization } from '../components/OrganizationProvider';
// import { sampleClosingSummaries } from './mockData';
import { track } from './analytics';
import { getAudience, getScopes } from './auth0Utils';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PortalNotification } from '../types'
const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export function useGetNotification(orderKey: string, notificationId: string, search: string, options = {}, queryOptions?: Omit<UseQueryOptions<PortalNotification, Error, PortalNotification, any[]>, 'queryKey' | 'queryFn'>) {
  return useApiQuery<PortalNotification>(`order/${orderKey}/notification/${notificationId}${search}`, options, queryOptions);
}

export function useGetNotificationStatusesV2(orderKey: string, notificationKey: string, search: string, options = {}, queryOptions?: Omit<UseQueryOptions<Partial<PortalNotification>, Error, Partial<PortalNotification>, any[]>, 'queryKey' | 'queryFn'>) {
  return useApiQuery<Partial<PortalNotification>>(`order/${orderKey}/notification/${notificationKey}/eventStatuses${search}`, options, queryOptions);
}

export function useApiQuery<TResponse>(
  path: string,
  options = {},
  queryOptions?: Omit<UseQueryOptions<TResponse, Error, TResponse, any[]>, 'queryKey' | 'queryFn'>
) {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();
  const organization = useOrganization();
  const scope = getScopes(organization?.MfaRequired);
  const audience = getAudience(organization?.MfaRequired);

  // Create a key for caching
  // @ts-ignore
  const bodyKey = options.body ? JSON.parse(options.body) : undefined;
  const queryKey = ['api', path, bodyKey];


  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: async () => {
      const url = `${origin}/api/${path}`;

      // Try getting the token silently
      let accessToken = '';
      try {
        accessToken = await getAccessTokenSilently({ audience, scope });
      } catch (e) {
        console.warn('getAccessTokenSilently() FAILED, redirecting to login…', e);
        await loginWithRedirect({
          appState: { returnTo: window.location.pathname + window.location.search }
        });
        throw new Error('Authentication required');
      }

      // @ts-ignore
      const { ...fetchOptions } = options;

      const res = await fetch(url, {
        ...fetchOptions,
        headers: {
          // @ts-ignore
          ...fetchOptions.headers,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      });

      if (res.ok) {
        try {
          const jsonResponse = await res.json();
          console.log('useApiTanstack', { path, jsonResponse });
          return jsonResponse as TResponse;
        } catch (e) {
          // Handle empty response
          track('error', 'useApiTanstack', {}, {
            message: 'Empty success response, returning empty object',
            error: JSON.stringify(e),
          });
          return {} as TResponse;
        }
      } else {
        let errorData: any = null;
        try {
          errorData = await res.json();
        } catch (e) {
          track('error', 'useApiTanstack', {}, {
            message: 'Failed to parse error response as JSON',
            error: JSON.stringify(e),
          });
          errorData = { userErrorMessage: 'An error occurred' };
        }
        throw errorData;
      }
    }
  });
}